"use client"
import { createContext, useState } from "react";

export const AppContext = createContext();
export default function DataContext({children}){
    
    const [courseData,setCourseData] = useState([{}]);
    
    return(
        <AppContext.Provider value={{courseData,setCourseData}}>
            {children}
        </AppContext.Provider>
    )
}
